module.exports = "/static/assets/3d72263b5e65bd03415f08f8b47faa4f.png";